'use client';
import * as React from 'react';

var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgTools = function SvgTools(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m11.836 15 5 5a2.122 2.122 0 0 0 3-3l-5-5",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M20.917 5.847a.2.2 0 0 1 .05.085c.47 1.567.107 3.33-1.131 4.568-1.251 1.25-3.038 1.609-4.617 1.117l-8.347 8.347c-.813.813-2.14.874-2.98.09A2.12 2.12 0 0 1 3.836 17l8.383-8.383c-.492-1.58-.134-3.366 1.117-4.617 1.238-1.238 3-1.602 4.568-1.132a.2.2 0 0 1 .085.05l.162.163a.2.2 0 0 1 0 .283L15.516 6l2.32 2.32 2.636-2.636a.2.2 0 0 1 .283 0zM2.934 4.293l.674 2.023A1 1 0 0 0 4.557 7h2.279V4.721a1 1 0 0 0-.684-.949l-2.023-.674a.5.5 0 0 0-.512.121l-.562.562a.5.5 0 0 0-.121.512M6.842 7l3.5 3.5",
    vectorEffect: "non-scaling-stroke"
  })));
};

export { SvgTools as default };
//# sourceMappingURL=tools.svg.js.map
